import React from "react";

import jsPDF from "jspdf";

class Module5PDFGenerator extends React.Component {
  genertatePDF() {
    var doc = new jsPDF("p", "pt");
    var width = doc.internal.pageSize.width;
    var height = doc.internal.pageSize.height;

    var data = require("./pdfData.json");

    //Page1
    doc.addImage(data[0].page1, "png", 0, 0, width, height);

    //Page2
    doc.addPage();
    doc.addImage(data[1].page2, 0, 0, width, height);

    //Page3
    doc.addPage();
    doc.addImage(data[2].page3, 0, 0, width, height);

    //Page4
    doc.addPage();
    doc.addImage(data[3].page4, 0, 0, width, height);

    doc.save("I am ready to apply for a job or PhD.pdf");
  }

  render() {
    return <div></div>;
  }
}

export default Module5PDFGenerator;
